import { render, staticRenderFns } from "./DropdownDatePicker.vue?vue&type=template&id=b8b4237a&scoped=true&"
import script from "./DropdownDatePicker.vue?vue&type=script&lang=js&"
export * from "./DropdownDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./DropdownDatePicker.vue?vue&type=style&index=0&id=b8b4237a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b4237a",
  null
  
)

export default component.exports